import axios from "axios";

export default class ParticipationVoteController {
    static async store(participationId: string | number, score: number) {
        const result = await axios.post<Jury.Resources.Vote>(`/api/jury/participations/${participationId}/vote`, { score })
        return result.data
    }
}